const prefix = "app/ReportsV2/ReportAdmin"

export const GET_STATUS_WATCHER = `${prefix}/GET_STATUS_WATCHER`
export const GET_STATUS_SUCCESS = `${prefix}/GET_STATUS_SUCCESS`
export const GET_STATUS_FAILED = `${prefix}/GET_STATUS_FAILED`

export const GET_MEASURE_COLOR_RANGE_WATCHER = `${prefix}/GET_MEASURE_COLOR_RANGE_WATCHER`
export const GET_MEASURE_COLOR_RANGE_SUCCESS = `${prefix}/GET_MEASURE_COLOR_RANGE_SUCCESS`
export const GET_MEASURE_COLOR_RANGE_FAILED = `${prefix}/GET_MEASURE_COLOR_RANGE_FAILED`

export const SAVE_CONFIG_BENCHMARK_WATCHER = `${prefix}/SAVE_CONFIG_BENCHMARK_WATCHER`
export const SAVE_CONFIG_BENCHMARK_SUCCESS = `${prefix}/SAVE_CONFIG_BENCHMARK_SUCCESS`
export const SAVE_CONFIG_BENCHMARK_FAILED = `${prefix}/SAVE_CONFIG_BENCHMARK_FAILED`
